import React from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Icon } from "../components/Icon";
import { ContactCTA } from "../components/sections/ContactCTA";
import { ABOUT } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export default function About() {
  const { t } = useLang();
  return (
    <>
      <PageHero overline={t(ABOUT.hero.overline)} title={t(ABOUT.hero.title)} subtitle={t(ABOUT.hero.subtitle)} />

      <section data-testid="about-intro-section" className="relative py-20 md:py-28">
        <div className="mx-auto max-w-3xl px-6 md:px-12">
          <Reveal>
            <span className="font-mono text-xs tracking-[0.28em] uppercase text-[#60A5FA]">{t(ABOUT.intro.heading)}</span>
          </Reveal>
          <div className="mt-6 space-y-5">
            {ABOUT.intro.paragraphs.map((p, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <p className="text-lg text-white/60 leading-relaxed">{t(p)}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="about-areas-section" className="relative py-20 md:py-28 border-t border-white/5">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Reveal>
            <span className="font-mono text-xs tracking-[0.28em] uppercase text-[#60A5FA]">{t(ABOUT.areas.heading)}</span>
          </Reveal>
          <div className="mt-8 flex flex-wrap gap-3">
            {ABOUT.areas.items.map((area, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <span
                  data-testid={`about-area-${i}`}
                  className="inline-block rounded-full border border-white/10 bg-white/[0.03] px-5 py-2.5 text-sm text-white/75 font-mono"
                >
                  {t(area)}
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="about-values-section" className="relative py-20 md:py-28 border-t border-white/5">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Reveal>
            <span className="font-mono text-xs tracking-[0.28em] uppercase text-[#60A5FA]">{t(ABOUT.values.heading)}</span>
          </Reveal>
          <div className="mt-10 grid gap-x-12 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
            {ABOUT.values.items.map((item, i) => (
              <Reveal key={i} delay={(i % 3) * 0.08}>
                <div data-testid={`about-value-${i}`} className="border-t border-white/10 pt-6">
                  <Icon name={item.icon} className="h-5 w-5 text-[#60A5FA]" />
                  <h3 className="mt-5 text-xl font-medium tracking-tight text-white">{t(item.title)}</h3>
                  <p className="mt-3 text-white/50 leading-relaxed">{t(item.desc)}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}
